module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Printer-090f98003869d99154a5f7c66bc7c36b.svg";